import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';
import fixAmAndPm from '../../../../../utils/fixAmAndPm';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck';

/**
 * Returns an assignment item that can be displayed in the 7 to 9 day posted schedule.
 * It will be visible in the day the parent tour's start time. The color/design is based upon one of four options that it is
 * assigned based upon the order it falls in the assignment array.
 * @param {*} rId
 * @param {*} dayType
 * @param {*} assignment
 * @param {*} assignmentCase
 */
const generateAssignments = (resource, dayType, assignment, assignmentCase, tourStartTime, timeOffset, startDate, scheduleType, scheduleFormat, scheduleLength) => {
  const { rId } = resource;
  const { startTime, endTime, jeId, jobId, requestNumber, status, comment, description, myAssignmentComment, isApproved } = assignment;

  let rdtId;
  let displayStartTime;
  let displayEndTime;
  if (tourStartTime) {
    rdtId = dayType.rdtId;
    displayStartTime = moment(tourStartTime).startOf('day');
    displayEndTime = moment(tourStartTime).endOf('day');
  } else { // stand-by assignment jeStatus === 10?
    rdtId = dayType.assignment.jeId;
    displayStartTime = moment.unix(startTime).add(timeOffset, 'minutes').startOf('day');
    displayEndTime = moment.unix(startTime).add(timeOffset, 'minutes').endOf('day');
  }

  let hasComment = false;
  if (comment || description || myAssignmentComment) {
    hasComment = true;
  }

  let itemStyle;
  if (assignmentCase === 3) {
    if (assignment && assignment.reconciled === '1') {
      itemStyle = getItemStyles(4);
    } else if (assignment.status === '20') {
      itemStyle = getItemStyles(5);
    } else {
      itemStyle = getItemStyles(3);
    }
  } else {
    itemStyle = getItemStyles(assignmentCase);
  }

  // const itemStyle = getItemStyles(assignmentCase);
  // const assignmentStartTime = moment(moment.unix(startTime)).add(timeOffset, 'minutes');
  // const assignmentEndTime = moment(moment.unix(endTime)).add(timeOffset, 'minutes');

  const assignmentStartTime = moment.unix(startTime);
  const assignmentEndTime = moment.unix(endTime);

  let DSTNeutralAssignmentStartTime = moment.utc(assignmentStartTime).clone();
  let DSTNeutralAssignmentEndTime = moment.utc(assignmentEndTime).clone();

  // blank assignments are where startTime is equal to endTime on 7&9 day schedules
  let blankAssignment;
  if (DSTNeutralAssignmentStartTime.format() === DSTNeutralAssignmentEndTime.format()) {
    blankAssignment = true;
  }

  const assignmentAdjusted = {
    id: jeId,
    jobId,
    requestNumber,
    itemType: 'assignment',
    group: rId,
    start_time: displayStartTime,
    end_time: displayEndTime,
    title: !blankAssignment ? fixAmAndPm(moment(DSTNeutralAssignmentStartTime).format('h:mma')) + '-'
      + fixAmAndPm(moment(DSTNeutralAssignmentEndTime).format('h:mma')) : '',
    modalStartTime: moment(DSTNeutralAssignmentStartTime).format('MM-DD-YYYY h:mma'),
    modalEndTime: moment(DSTNeutralAssignmentEndTime).format('MM-DD-YYYY h:mma'),
    rdtId,
    status,
    backgroundColor: !assignment.isApproved ? itemStyle.backgroundColor : "gray",
    color: itemStyle.color,
    borderStyle: itemStyle.borderStyle,
    borderColor: hasComment ? "red" : itemStyle.borderColor,
    resourceClass: resource.class,
    isApproved
  };

  return assignmentAdjusted;
}

export default generateAssignments;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateAssignments.js